var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcWalletWBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#9d9fcc}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "ic-wallet-w-bill",
    transform: "translate(-772.409 -422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg-transparent",
    transform: "translate(772.409 422)",
    style: {
      fill: "none"
    },
    d: "M0 0h36v36H0z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet",
    transform: "translate(777.619 428.341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_315",
    "data-name": "\\uD328\\uC2A4 315",
    className: "cls-2",
    d: "M112.558 78a2.558 2.558 0 1 0 2.558 2.558A2.558 2.558 0 0 0 112.558 78zm0 3.837a1.279 1.279 0 1 1 1.279-1.279 1.28 1.28 0 0 1-1.279 1.279z",
    transform: "translate(-107.442 -64.357)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_316",
    "data-name": "\\uD328\\uC2A4 316",
    className: "cls-2",
    d: "M130.3 64.443h-1.323l-2.091-7.059a.969.969 0 0 0-.914-.718.9.9 0 0 0-.29.049l-16.456 5.612a1.046 1.046 0 0 0-.624 1.293l.244.823h-1.568A1.328 1.328 0 0 0 106 65.815v16.469a1.328 1.328 0 0 0 1.279 1.372H130.3a1.328 1.328 0 0 0 1.279-1.372V65.815a1.328 1.328 0 0 0-1.279-1.372zm-4.536-6.316 1.871 6.316h-17.446l-.271-.913zm4.536 9.747h-3.2a.688.688 0 0 0 0 1.372h3.2v13.038h-23.021V69.246h14.709a.688.688 0 0 0 0-1.372h-14.709v-2.059H130.3z",
    transform: "translate(-106 -58.501)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWalletWBill);
export default __webpack_public_path__ + "static/media/ic-wallet-w-bill.98fc542327667f69c004b665989ba770.svg";
export { ForwardRef as ReactComponent };